import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getSettingHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/setting/_layout/field/")({
    component: FieldsSettingsPage,
    staticData: {
        permissions: [PermissionEnum.SettingField],
        showInSideMenu: false,
        label: "pages.setting.field.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.setting.field.title"),
        };
    },
});

function FieldsSettingsPage() {
    return (
        <TenantPage headerNavigationItems={getSettingHeaderItems} isEdit={true}>
            <></>
        </TenantPage>
    );
}
